import {useConfig} from "./hooks/useConfig"
import React, {ReactNode, useEffect, useRef} from "react"
import "./style.css"
import {usePatchState} from "./hooks/usePatchState"
import {GiphyWidget} from "./GiphyWidget";
import {Category, Item, Images, SmileType} from "./Images";

interface DirJsonObject {
    type: 'directory' | 'file' | 'report'
    name: string
    contents: DirJsonObject[]
    directories?: number
    files?: number
}

interface SmileJsonObject {
    url: string
    code: string
}

interface SmilesCategoryJsonObject {
    title: string
}

interface SmilesCategoriesJsonObject {
    [key: string]: SmilesCategoryJsonObject
}

interface AppState {
    isLoading: boolean
    error: Error | null
    categories: Category[]
    clipboardType: SmileType
    clipboard: string
}

const initialState: AppState = {
    isLoading: true,
    error: null,
    categories: [],
    clipboardType: 'none',
    clipboard: "",
}

let smilesGlobalIndex = 10000
let globalIndex = 20000

function getCategoryNameAndIndex(objectName: string): [string, number] {
    const parts = objectName.split('.')

    if (parts.length > 1) {
        const idx = parseInt(parts[0])

        return [parts[1], idx]
    } else {
        return [objectName, globalIndex++]
    }
}

function transformDirItems(objects: DirJsonObject[]): Item[] {
    console.log('Процессим папку', objects)

    const images: Item[] = []

    if (objects.length <= 0) {
        return []
    }

    objects.forEach(obj => {
        images.push({
            id: obj.name,
            url: '',
        })
    })

    return images
}

function transformDirCategories(objects: DirJsonObject[]): Category[] {
    console.log('Процессим раздел', objects)

    const categories: Category[] = []

    if (objects.length <= 0) {
        return []
    }

    objects[0].contents.forEach((obj) => {
        if (obj.contents === undefined) {
            return
        }

        const items = transformDirItems(obj.contents)

        if (items.length > 0) {
            const [name, index] = getCategoryNameAndIndex(obj.name)

            categories.push({
                index: index,
                type: 'image',
                title: name,
                dir: obj.name,
                items: items,
            })
        }
    })

    return categories.slice().sort((a, b) => b.index - a.index)
}

function transformResults(
    dirs: DirJsonObject[],
    smiles: SmileJsonObject[],
    smilesCategories: SmilesCategoriesJsonObject,
): Category[] {
    const categories: Category[] = []

    const categoriesMap: Map<string, Category> = new Map()
    const categoriesKeys: string[] = []

    Object.keys(smilesCategories).forEach((key, index) => {
        const smileCategory = smilesCategories[key]

        const category: Category = {
            index: smilesGlobalIndex + index,
            type: 'smile',
            title: smileCategory.title,
            items: [],
        }

        categoriesMap.set(key, category)
        categoriesKeys.push(key)

        console.log('Категория', category)
    })

    const otherCategory: Category = {
        index: smilesGlobalIndex + categoriesKeys.length + 1,
        type: 'smile',
        title: 'Другие',
        items: [],
    }

    console.log('Категория other', otherCategory)

    smiles.forEach(smile => {
        const split = smile.code.split(':')
        if (split.length < 2) {
            return
        }
        const smilePart = split[1]
        const smileSplit = smilePart.split('_')
        if (smileSplit.length <= 1) {
            otherCategory.items.push({
                id: smile.code,
                url: smile.url,
            })

            console.log('Смайл', smile, 'добавлен в категорию other')
        } else {
            const categoryId = smileSplit[0]

            const item: Item = {
                id: smile.code,
                url: smile.url,
            }

            const currentCategory = categoriesMap.get(categoryId)

            if (currentCategory === undefined) {
                otherCategory.items.push(item)

                console.log('Смайл', smile, 'добавлен в категорию other')
            } else {
                currentCategory.items.push(item)

                console.log('Смайл', smile, 'добавлен в категорию', currentCategory.index, currentCategory.title)
            }
        }
    })

    categoriesKeys.forEach(key => {
        const category = categoriesMap.get(key)
        if (category !== undefined && category.items.length > 0) {
            categories.push(category)
        } else {
            console.log('Категори', category ? (category.index + ' :: ' + category.title) : category, 'отфильтрована')
        }
    })

    if(otherCategory.items.length > 0) {
        categories.push(otherCategory)
    } else {
        console.log('Категори', otherCategory.index + ' :: ' + otherCategory.title, 'отфильтрована')
    }

    transformDirCategories(dirs).forEach(category => {
        if(category.items.length > 0) {
            categories.push(category)

            console.log('Добавлена категория из папки', category.index, category.title)
        } else {
            console.log('Отфильтрована категория из папки', category.index, category.title)
        }
    })

    return categories
}

export const App = () => {
    const config = useConfig()
    const clipboardRef = useRef<HTMLInputElement>(null)
    const [state, patchState] = usePatchState<AppState>(initialState)

    useEffect(() => {
        const cssUrl = config.storageBaseUrl + "/style.css?v=0.3&_t" + new Date().getTime()
        const heads = document.getElementsByTagName('head')
        if(heads.length > 0) {
            const head = heads.item(0)
            if (head !== null) {
                const link = document.createElement('link')
                link.rel = 'stylesheet'
                link.type = 'text/css'
                link.media = 'all'
                link.href = cssUrl

                head.appendChild(link)
            }
        }

        const dirPromise = fetch(config.storageBaseUrl + '/dir.json', {method: 'GET'})
            .then(res => res.json())
            .then(res => res as DirJsonObject[])
            .catch(e => {
                console.error("Failed to load dir.json", e)
                return []
            })

        const smilesPromise = fetch(config.storageBaseUrl + '/smiles.json', {method: 'GET'})
            .then(res => res.json())
            .then(res => res as SmileJsonObject[])
            .catch(e => {
                console.error("Failed to load smiles.json", e)
                return []
            })

        const categoriesPromise = fetch(config.storageBaseUrl + '/categories.json', {method: 'GET'})
            .then(res => res.text())
            .then(res => {
                let result: SmilesCategoriesJsonObject = {}
                eval('result = ' + res) // @todo not safe
                return result
            })
            .catch(e => {
                console.error("Failed to load categories.json", e)
                return {}
            })

        Promise.all([dirPromise, smilesPromise, categoriesPromise])
            .then(([dirs, smiles, smilesCategories]) => {
                patchState({
                    isLoading: false,
                    error: null,
                    categories: transformResults(dirs, smiles, smilesCategories),
                })
            })
            .catch(err => patchState({
                isLoading: false,
                error: err,
                categories: [],
            }))
    }, [config.storageBaseUrl, patchState])

    if (state.isLoading) {
        return <div style={{padding: '1rem'}}>Загрузка...</div>
    } else if (state.error !== null) {
        return <div style={{padding: '1rem', color: 'red'}}>Error: {state.error.message}</div>
    }

    const onClipboard = (type: SmileType, url: string) => {
        // const showToast = () => {
        //     const x = document.getElementById("toast")
        //
        //     if (x !== null) {
        //         x.className = "show"
        //
        //         setTimeout(function () {
        //             x.className = x.className.replace("show", "")
        //         }, 2000)
        //     }
        // }
        //
        // clipboardCopy(url, showToast)

        patchState({
            clipboardType: type,
            clipboard: url,
        })

        setTimeout(() => {
            window.scrollTo(0, 0)

            if (clipboardRef.current !== null) {
                clipboardRef.current.focus()
                clipboardRef.current.select()
            }
        })
    }

    let giphyElem: ReactNode = undefined

    if (config.giphyEnabled) {
        giphyElem = (
            <div className="tab">
                <input type="checkbox" id="cb-giphy" defaultChecked={true}/>
                <label htmlFor="cb-giphy" className="tab__label">Поиск с giphy.com</label>
                <div className="tab__content">
                    <GiphyWidget onClipboard={onClipboard}/>
                </div>
            </div>
        )
    }

    let clipboardInput: ReactNode = undefined

    if (state.clipboard !== "") {
        clipboardInput = (
            <div>
                <h2>Скопируйте {state.clipboardType === 'smile' ? "код смайлика" : "ссылку"}</h2>
                <div style={{paddingBottom: '2rem'}}>
                    <input
                        ref={clipboardRef}
                        value={state.clipboard}
                        readOnly={true}
                        type="text"
                        style={{width: '100%'}}
                    />
                </div>
            </div>
        )
    }

    return (
        <>
            {clipboardInput}
            <section className="accordion">
                {giphyElem}
                <Images categories={state.categories} onClipboard={onClipboard}/>
            </section>
            {/*<div id="toast">*/}
            {/*    <div id="img"></div>*/}
            {/*    <div id="desc">Ссылка скопирована в буфер обмена</div>*/}
            {/*</div>*/}
        </>
    )
}
